export default __webpack_public_path__ + "static/media/fireFN34.eb4f191b.svg";